module.exports = __webpack_public_path__ + "static/media/thumb_resumy.ae76aa10.png";